import useUpdateEffect from '@hooks/useUpdateEffect';
import { usePathname } from 'next/navigation';

export const useOnRouteChange = (cb: () => void | (() => void)) => {
  const pathname = usePathname();

  useUpdateEffect(cb, [pathname]);
};
